import HedgeBalanceBook from './index';

export default { path: '/home/hedge/balance/book', component: HedgeBalanceBook };